import { useQuery } from '@tanstack/react-query';
import { SalesMetrosService } from '../services';
import { salesMetrosKeys } from '../queryKeys';

/**
 * Every sales metro, Unassigned included, for the Sales Metros page. The key
 * is the one a save of a metro's admins invalidates.
 *
 * `retry: false` so an organization-service outage reaches the page's error
 * state at once rather than after three silent retries.
 */
export const useSalesMetrosForManagement = () => {
  const { data, isError, isPending, isFetching } = useQuery({
    queryKey: salesMetrosKeys.list(),
    queryFn: () => SalesMetrosService.listSalesMetrosForManagement(),
    retry: false,
  });

  return {
    metros: data ?? [],
    isPending,
    isFetching,
    isError,
  };
};
